import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta:{title:'首页'}
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/downloadApp',
    name: 'downloadApp',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/downloadApp.vue'),
    meta:{title:'下载APP'}

  },
  {
    path: '/problem',
    name: 'problem',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../h5/problem/problem.vue'),
    meta:{title:'常见问题'}
  },
  {
    path: '/problem/detail',
    name: 'problemDetail',
    component: () => import(/* webpackChunkName: "about" */ '../h5/problem/detail.vue'),
    meta:{title:'常见问题'}
  },
  {
    path: '/problem/appTypeDetail',
    name: 'appTypeDetail',
    component: () => import(/* webpackChunkName: "about" */ '../h5/problem/appTypeDetail.vue'),
    meta:{title:'服务条款说明'}
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: './',
  routes
})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
      document.title = to.meta.title;
  }else{
      document.title = '';
  }
  next();
})
export default router
